module.exports = __webpack_public_path__ + "img/coins.e9aa754e.svg";